import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/blocked_reason`,
    name: 'POST_BLOCKED_REASON',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
